/**
 * Builds the CDN base URL for a versioned folder of static assets under `public/`.
 *
 * Public-folder assets are not rewritten by Next.js `assetPrefix`, so it has to be
 * prepended manually. `ASSET_PREFIX` is exposed to the client through the `env`
 * block in `next.config.ts`, and resolves to the CDN
 * (frontends[-dev].udemycdn.com/<app>) in dev/prod and to the app-name path
 * locally, where a rewrite maps it back to /public.
 *
 * Assets are served with a 1-year immutable cache in production, so folders are
 * versioned (`v1`, `v2`, …) and a changed asset means a new folder rather than an
 * overwrite.
 *
 * @param folder - Versioned folder inside `public/`, e.g. `landing-banner/v1`
 * @returns The base URL with no trailing slash, so joins never produce `//`
 */
export function getAssetBase(folder: string): string {
    const prefix = (process.env.ASSET_PREFIX ?? '').replace(/\/$/, '');

    return `${prefix}/${folder.replace(/^\/|\/$/g, '')}`;
}
